import moment from 'moment'
import constants, {
  DEFAULT_SERVICE_FEE_PERCENT,
  ETH_MAINNET_FEE_USD,
} from '../utils/constants'
import { removeExcessDecimals } from './totals'
/* eslint-disable operator-linebreak */
export const getCosting = (preferences, trip = {}, maxDecimals = 6) => {
  // Room costing
  let totalRoomCost = 0

  preferences.rooms &&
    preferences.rooms.forEach((room) => {
      totalRoomCost += (room.variant ? room.variant.cost : 0) * room.attendees
    })
  totalRoomCost = parseFloat(totalRoomCost > 0 ? totalRoomCost.toFixed(2) : 0)

  // add on costing
  let totalAddOnCost = 0
  preferences.addOns?.map((addOn) => {
    totalAddOnCost += addOn.variant?.cost * addOn.attendees
    return addOn
  })
  totalAddOnCost = parseFloat(
    totalAddOnCost > 0 ? totalAddOnCost.toFixed(2) : 0,
  )

  // discounts
  let discountedAddOnCost = totalAddOnCost
  // Total before discount
  const grandTotal = totalAddOnCost + totalRoomCost
  // Total discounted price
  let discountedGrandTotal = grandTotal
  if (preferences?.discounts?.length > 0) {
    preferences.discounts?.forEach((d) => {
      if (d.discType === 'amount') {
        discountedGrandTotal = discountedGrandTotal - d.amount
        discountedAddOnCost = discountedAddOnCost - d.amount
      } else if (d.discType === 'percentage') {
        discountedGrandTotal =
          discountedGrandTotal - (discountedGrandTotal * d.amount) / 100
        discountedAddOnCost =
          discountedAddOnCost - (discountedAddOnCost * d.amount) / 100
      }
    })
  }

  // Apply coupon for add ons
  if (preferences.coupon) {
    if (preferences.coupon.discType === 'amount') {
      discountedGrandTotal = discountedGrandTotal - preferences.coupon.amount
      discountedAddOnCost = discountedAddOnCost - preferences.coupon.amount
    } else if (preferences.coupon.discType === 'percentage') {
      discountedGrandTotal =
        discountedGrandTotal -
        (discountedGrandTotal * preferences.coupon.amount) / 100
      discountedAddOnCost =
        discountedAddOnCost -
        (discountedAddOnCost * preferences.coupon.amount) / 100
    }
  }

  // Remove negative values
  discountedGrandTotal = parseFloat(
    discountedGrandTotal > 0 ? discountedGrandTotal.toFixed(2) : 0,
  )
  discountedAddOnCost = parseFloat(
    discountedAddOnCost > 0 ? discountedAddOnCost.toFixed(2) : 0,
  )

  // Total discount
  const discountTotal = grandTotal - discountedGrandTotal
  let paynowAmount = discountedGrandTotal
  let payFutureAmount = 0

  if (
    preferences.payment === 'deposit' &&
    trip?.isDepositApplicable &&
    trip?.deposit
  ) {
    paynowAmount = trip.deposit.amount * preferences.attendees
    if (trip?.deposit?.includeAddOns) {
      paynowAmount = paynowAmount + discountedAddOnCost
    }
  }
  if (paynowAmount >= discountedGrandTotal) {
    paynowAmount = discountedGrandTotal
  } else {
    payFutureAmount = discountedGrandTotal - paynowAmount
  }
  let serviceFee = 0
  let futureServiceFee = 0
  let platformFee = 0
  let cardFee = 0
  let ethMainnetFee = 0
  let futureCardFee = 0
  let futurePlatformFee = 0
  let futureEthMainnetFee = 0

  if (paynowAmount > 0 && preferences?.paymentMethodType) {
    const precentCharge =
      trip?.organization?.serviceFee == undefined
        ? DEFAULT_SERVICE_FEE_PERCENT
        : trip?.organization?.serviceFee
    // platform fee
    platformFee = (paynowAmount * precentCharge) / 100
    if (payFutureAmount > 0)
      futurePlatformFee = (payFutureAmount * precentCharge) / 100

    // Apply card processing fee
    if (preferences?.paymentMethodType == 'cards') {
      cardFee =
        ((paynowAmount + platformFee) * constants.CC_CHARGE_FEE) / 100 +
        constants.CC_CHARGE_FIXED_VALUE
      if (payFutureAmount > 0)
        futureCardFee =
          ((payFutureAmount + futurePlatformFee) * constants.CC_CHARGE_FEE) /
            100 +
          constants.CC_CHARGE_FIXED_VALUE
    }

    // Apply crypto mainnet fee
    if (
      preferences?.cryptoPaymentMethod?.chainId === 1 &&
      preferences?.paymentMethodType == 'crypto'
    ) {
      ethMainnetFee = ETH_MAINNET_FEE_USD
      if (payFutureAmount > 0) futureEthMainnetFee = ETH_MAINNET_FEE_USD
    }

    // Total service fee
    serviceFee = removeExcessDecimals(
      platformFee + cardFee + ethMainnetFee,
      maxDecimals,
    )
    futureServiceFee = removeExcessDecimals(
      futurePlatformFee + futureCardFee + futureEthMainnetFee,
      maxDecimals,
    )
  }

  discountedGrandTotal = removeExcessDecimals(discountedGrandTotal, maxDecimals)
  paynowAmount = removeExcessDecimals(paynowAmount, maxDecimals)
  payFutureAmount = removeExcessDecimals(payFutureAmount, maxDecimals)

  //   paynowAmount,
  //   discountedGrandTotal,
  //   discountTotal,
  //   grandTotal,
  //   totalRoomCost,
  //   totalAddOnCost,
  //   discountApplies: preferences.discountApplies,
  //   serviceFee,
  //   platformFee,
  //   cardFee,
  //   ethMainnetFee,
  //   futureCardFee,
  //   futurePlatformFee,
  //   futureServiceFee,
  //   payFutureAmount,
  // })
  return {
    paynowAmount,
    discountedGrandTotal,
    discountTotal,
    grandTotal,
    totalRoomCost,
    totalAddOnCost,
    discountApplies: preferences.discountApplies,
    serviceFee,
    platformFee,
    cardFee,
    ethMainnetFee,
    futureCardFee,
    futurePlatformFee,
    futureServiceFee,
    payFutureAmount,
    futureEthMainnetFee,
  }
}
export const getDepositStatus = (trip) => {
  if (
    trip?.isDepositApplicable &&
    trip?.deposit &&
    trip?.deposit?.expirationDate
  ) {
    const expiration = moment.unix(trip?.deposit?.expirationDate).endOf('day')
    const startDate = moment(trip?.startDate?.toString(), 'YYYYMMDD').endOf(
      'day',
    )
    return (
      expiration.diff(moment(), 'days') >= 0 &&
      startDate.diff(moment(), 'days') >= 30
    )
  } else return false
}
export const getServiceFee = (booking, trip = {}) => {
  const { discountAddonFare, discountBaseFare, serviceFee, paymentMethodType } =
    booking || {}
  const totalFare = discountAddonFare + discountBaseFare
  let platformFee = 0
  let cardFee = 0
  if (totalFare > 0 && paymentMethodType) {
    if (!trip?.organization?.isConcierge) {
      platformFee =
        (totalFare *
          (trip?.organization?.serviceFee || DEFAULT_SERVICE_FEE_PERCENT)) /
        100
    }
    if (paymentMethodType == 'cards') {
      cardFee = serviceFee - platformFee
    }
  }
  return { platformFee, cardFee }
}
